<template>
  <div class="baseParameters">
<!--    <div class="topTitle">-->
<!--      <span class="title">特性管理</span>-->
<!--      <div class="action-btn">-->
<!--        <a-button class="btn" type="primary" @click="handleSubmit" :loading="btnLoading" v-if="$auth('featureManagement.add') || $auth('featureManagement.edit')">保存</a-button>-->
<!--      </div>-->
<!--    </div>-->
    <div class="topTitle">
      <div class="title">
        <span>特性管理</span>
      </div>
    </div>
    <div class="btnGroup">
      <a-button class="btn" type="primary" @click="handleSubmit" :loading="btnLoading" v-if="$auth('featureManagement.add') || $auth('featureManagement.edit')">保存</a-button>
    </div>
    <a-form :form="form" @submit="handleSubmit" class="parameterConfiguration">
      <div class="basicParameters">
        <div class="titleDiv">
          <div class="title">基本信息</div>
        </div>
        <a-row>
          <a-col :span="6">
            <a-form-item label="特性名称" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input
                placeholder="请输入特性名称"
                autocomplete="off"
                v-decorator="['name',{validateTrigger: ['blur'],rules: [{ required: true, message: '请输入特性名称!' }]}]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="父节点" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input
                autocomplete="off"
                :disabled="true"
                v-decorator="['pName',{validateTrigger: ['blur'],rules: [{ required: true, message: '请输入父节点!' }]}]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="特性状态" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-select v-decorator="['status',{validateTrigger: ['change'],rules: [{ required: true, message: '请选择状态!' }]}]" :allowClear="true" placeholder="请选择状态" @change="changeStatus">
                <a-select-option v-for="(item, index) in statusList" :key="index" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="系统特性" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-select v-decorator="['requiredState',{validateTrigger: ['change'],rules: [{ required: true, message: '请选择状态!' }]}]" :allowClear="true" placeholder="请选择状态">
                <a-select-option v-for="(item, index) in yseOrNoList" :key="index" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <div class="titleDiv">
          <div class="title">关联参数</div>
        </div>
        <a-row class="generalParameter">
          <a-col :span="6" v-for="(item, index) in generalList">
            <a-form-item :labelCol="labelColAll" :wrapperCol="wrapperColAll">
              <a-tree-select
                show-search
                :filterTreeNode="filterTreeNode"
                style="width: 100%"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                placeholder="请选择动设备参数"
                allow-clear
                tree-default-expand-all
                :treeData="generalParameterList"
                v-model="item.code"
                :replaceFields="{
                  title: 'name',
                  key: 'key',
                  value: 'code'
                }"
                @change="(value, label, extra) => changeEquipmentParamTypeCode(value, label, extra, item, index)"
              ></a-tree-select>
              <a-icon type="close-square" theme="filled"  class="delIcon" @click="del_general(item, index)"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label-col="labelColAll" :wrapper-col="wrapperColAll">
              <a-button block type="dashed" icon="plus" @click="add_general" class="addBtn_general">添加</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </div>
    </a-form>
  </div>
</template>

<script>
import { editEquipmentParameters, getEquipmentDetail, getIcon, saveEquipmentParameters } from '@/api/featureManagement'
import { mapGetters } from 'vuex'
import { addDeviceType, checkParam, editDeviceType } from '@/api/deviceType'
import { checkFieldDelete, getTreeDeviceType } from '@/api/deviceParameter'

export default {
  props: {
    typeCode: String
  },
  computed: {
    ...mapGetters(['selectFeatureTree'])
  },
  watch: {
    selectFeatureTree: {
      handler (newVal) {
        console.log(newVal)
        switch (newVal.type) {
          case 'edit':
            this.type = 'edit'
            this.dataForm = newVal.data
            this.initData(newVal.data.id)
            break
          case 'add':
            this.type = 'add'
            const data = {
              'valueType': undefined,
              'valueOptions': '',
              'name': '',
              'pName': '一级特性',
              'requiredState': undefined,
              'status': undefined,
              'icon': ''
            }
            this.generalList = []
            this.initTableFormData(data)
            break
          case 'addChildren':
            this.type = 'addChildren'
            this.dataForm = newVal.data
            this.generalList = []
            this.initTableFormData(newVal.data)
            break
        }
      },
      deep: true
    }
  },
  created () {
    this.getIconList()
    this.getGeneralParameterList()
  },
  data () {
    return {
      btnLoading: false,
      labelCol: { style: 'width: 70px' },
      wrapperCol: { style: 'width: calc(100% - 82px)' },
      // 图标列表
      iconList: [],
      // 删除的数据列表
      delList: [],
      // 表单
      form: this.$form.createForm(this, { name: 'cancelApplication' }),
      dataForm: {},
      // 是否必填
      yseOrNoList: [
        {
          id: 1,
          name: '是'
        },
        {
          id: 0,
          name: '否'
        }
      ],
      // 特性状态
      statusList: [
        {
          id: 1,
          name: '在用'
        },
        {
          id: 2,
          name: '失效'
        }
      ],
      inputTypeList: [
        {
          id: 1,
          name: '填空'
        },
        {
          id: 2,
          name: '单选'
        }
      ],
      valueDisabled: false,
      generalList: [],
      generalVerifyList: [], // 验证
      labelColAll: {
        xs: { span: 24 },
        sm: { span: 0 }
      },
      wrapperColAll: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      generalParameterList: [],
      originalStatus: null,
      formId: null,
    }
  },
  methods: {
    // 获取特性参数详情
    initData (id) {
      const data = {
        id: id
      }
      getEquipmentDetail(data).then(res => {
        if (res.status === 0) {
          res.data.requiredState = res.data.requiredState ? 1 : 0
          this.dataForm = res.data
          this.generalList = res.data.peculiarityParamList
          this.initTableFormData(res.data)
        }
      })
    },
    // 设置表单
    initTableFormData (data) {
      this.$nextTick(() => {
        this.valueDisabled = false
        this.form.resetFields()
        this.findGeneral()
        this.originalStatus = data.status
        this.formId = data.id
        this.form.setFieldsValue({
          name: data.name,
          pName: data.pid === 0 ? '一级特性' : data.pName,
          // 系统特性
          requiredState: data.requiredState,
          status: data.status
        })
      })
    },
    // 获取图标列表
    getIconList () {
      getIcon({ pCode: 'txjttp' }).then(res => {
        if (res.status === 0) {
          this.iconList = res.data
        }
      })
    },
    // 改变特性状态
    changeStatus() {
      if (this.formId) {
        const data = {
          dataIndex: this.formId,
          type: 4
        }
        checkFieldDelete(data).then(res => {
          if (res.status === 0) {
            if (res.data) {
              this.$message.error('该特性已被使用，无法修改状态')
              this.form.setFieldsValue({
                status: this.originalStatus
              })
            }
          } else {
            this.$message.error(res.info.message)
          }
        }).catch(err => {
          this.$message.error(err.info.message)
        })
      }
    },
    // 获取常规参数列表
    getGeneralParameterList () {
      const data = {
        pCode: 'EQUIPMENT_PARAM'
      }
      getTreeDeviceType(data).then(res => {
        if (res.status === 0) {
          this.generalParameterList = res.data
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 改变常规参数选择
    changeEquipmentParamTypeCode (value, label, extra, data, index) {
      const that = this
      if (data.equipmentTypeId) {
        const params = {
          typeCode: this.generalVerifyList[index].code,
          typeId: this.deviceTypeStatus.data.id
        }
        checkParam(params).then(res => {
          if (res.status === 0) {
            if (res.data) {
              this.$confirm({
                title: '是否确定修改',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk () {
                  that.generalVerifyList[index].code = value
                  that.findGeneral()
                },
                onCancel () {
                  that.generalList[index].code = that.generalVerifyList[index].code
                  that.findGeneral()
                }
              })
            } else {
              that.generalVerifyList[index].code = value
              that.findGeneral()
            }
          }
        })
      }
      // extra.triggerNode.$options.propsData.dataRef.disabled = true
      this.findGeneral()
    },
    // 常规参数，找到传入的元素，并且给他复制disabled状态
    findGeneral () {
      const arr = this.generalList.map(item => {
        return item.code
      })
      function findChildren (data) {
        for (let i = 0; i < data.length; i++) {
          const j = data[i]
          if (arr.indexOf(j.code) >= 0) {
            j.disabled = true
          } else {
            j.disabled = false
          }
          if (j.children) {
            findChildren(j.children)
          }
        }
      }
      for (let i = 0; i < this.generalParameterList.length; i++) {
        const j = this.generalParameterList[i]
        if (arr.indexOf(j.code) >= 0) {
          j.disabled = true
        } else {
          j.disabled = false
        }
        if (j.children) {
          findChildren(j.children)
        }
      }
    },
    // 增加常规参数
    add_general () {
      this.generalList.push({
        code: undefined
      })
      this.generalVerifyList.push({
        code: undefined
      })
    },
    // 判断删除常规参数
    del_general (item, index) {
      if (item.equipmentTypeId) {
        // 调确认接口
        if (this.viewConfirmDel === null) {
          this.delGeneral(item, index)
        } else {
          this.showDeleteConfirm(item, index, '常规')
        }
      } else {
        this.generalList.splice(index, 1)
        this.generalVerifyList.splice(index, 1)
        this.findGeneral()
      }
    },
    // 常规参数树搜索
    filterTreeNode (inputValue, treeNode) {
      return treeNode.componentOptions.propsData.dataRef.name.indexOf(inputValue.toLowerCase()) > -1
    },
    // 保存
    handleSubmit () {
      this.form.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          const params = {
            name: value.name,
            requiredState: value.requiredState,
            status: value.status,
            typeCodeList: []
          }
          this.generalList.forEach(item => {
            if (item.code) {
              params.typeCodeList.push(item.code)
            }
          })
          this.btnLoading = true
          if (this.type === 'add' || this.type === 'addChildren') {
            if (this.type === 'add') {
              params.pid = 0
            } else {
              params.pid = this.dataForm.id
            }
            saveEquipmentParameters(params).then(res => {
              if (res && res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('initTree')
                this.initData(res.data)
                this.type = 'edit'
                this.btnLoading = false
              } else {
                this.$message.error(res.info.message)
                this.btnLoading = false
              }
            })
              .catch(err => {
                this.btnLoading = false
              })
          }
          if (this.type === 'edit') {
            params.id = this.dataForm.id
            params.pid = this.dataForm.pid
            editEquipmentParameters(params).then(res => {
              if (res && res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('initTree')
                this.initData(this.dataForm.id)
                this.btnLoading = false
              } else {
                this.$message.error(res.info.message)
                this.btnLoading = false
              }
            })
              .catch(err => {
                this.btnLoading = false
              })
          }
        }
      })
    },
    save () {
      for (let i = 0; i < this.baseData.length; i++) {
        const item = this.baseData[i]
        if (item.name === '' || item.requiredState === undefined || item.status === undefined || item.valueType === undefined || (item.valueType === 2 && item.valueOptions === '') || item.icon === undefined) {
          this.$message.error('请填写完整内容')
          return
        }
      }
      this.btnLoading = true
      const data = this.baseData.concat(this.delList)
      data.forEach((item, index) => {
        item.sort = index + 1
      })
      saveEquipmentParameters(data).then(res => {
        this.btnLoading = false
        if (res.status === 0) {
          this.$message.success('保存成功！')
          this.initData()
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(() => {
        this.btnLoading = false
        this.$message.error('保存参数出错，请联系管理员')
      })
    },
    remove (item, index) {
      const data = { ...item }
      if (data.id) {
        data.status = 9
        this.delList.push(data)
      }
      this.baseData.splice(index, 1)
    },
    add () {
      this.baseData.push(
        {
          'name': '',
          'requiredState': undefined,
          'status': undefined,
          'valueType': undefined,
          'valueOptions': '',
          'icon': undefined
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
.topTitle {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  .title span{
    font-weight: bold;
  }
}
.btnGroup {
  display: flex;
  padding: 11px 0 13px 0;
  border-top: 1px solid #DDDDDD;
}
.baseParameters{
  height: 100%;
  .zm-label{
    margin-bottom: 16px;
  }
  .ant-form-item{
    margin-bottom: 10px;
  }
  .other-data{
    position: relative;
    height: calc(100% - 44px);
    .action-btn{
      position: absolute;
      right: 10px;
      top: -36px;
      display: flex;
      .btn{
        margin-left: 10px;
      }
    }
    .item-label{
      margin: 0 0 10px 0 !important;
      background: #F5F5F5;
      .ant-col {
        padding: 10px 8px;
        border-top: 1px solid #DDDDDD;
        border-bottom: 1px solid #DDDDDD;
        border-right: 1px solid #DDDDDD;
      }
      .ant-col:nth-child(1) {
        border-left: 1px solid #DDDDDD;
      }
      .anticon{
        color: #1791FF;
        font-size: 14px;
        margin-left: 9px;
        margin-right: 9px;
      }
      .anticonTooltip{
        color: #1791FF;
        font-size: 12px;
      }
    }
    .dataInputDiv {
      max-height: calc(100% - 50px);
      overflow-y: scroll;
      position: relative;
    }
    .item-data{
      width: 100%;
      .anticon{
        color: #E73B3B;
        font-size: 20px;
      }
    }
  }
}
.addBtn {
  position: sticky;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
}
.fontWeight {
  font-weight: bold;
}
.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  .title{
    border-left: 4px solid #08409F;
    padding-left: 8px;
    color: #08409F;
  }
}
.generalParameter {
  /deep/.ant-col-6 {
    padding-left: 12px;
    .ant-form-item-children {
      display: flex;
      flex-direction: row;
      align-items: center;
      .ant-select {
        width: calc(100% - 28px);
        margin-right: 8px;
      }
      .delIcon {
        font-size: 20px;
        color: red;
      }
    }
  }
}
/deep/.ant-form-item {
  display: flex;
  margin-bottom: 12px;
}
</style>
